module.exports = "./img/ed6db885b1a6cbf01f161aa52688a5de.png";